/* Variant ready - ujawnia ukryte elementy */
(function () {
  let priceRevealed = false;
  let galleryRevealed = false;
  const preloadedUrls = new Set();

  function preloadImage(url) {
    if (!url || preloadedUrls.has(url)) return;
    preloadedUrls.add(url);
    var link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = url;
    document.head.appendChild(link);
  }

  function preloadConfiguratorImages() {
    var configurator = document.querySelector(".product-configurator");
    if (!configurator) return;
    var zooms = configurator.querySelectorAll(".image_zoom[data-image]");
    Array.from(zooms)
      .slice(0, 3)
      .forEach(function (z) {
        preloadImage(z.getAttribute("data-image"));
      });
  }

  var configurator = document.querySelector(".product-configurator");
  if (configurator) {
    preloadConfiguratorImages();
    var preloadObserver = new MutationObserver(preloadConfiguratorImages);
    preloadObserver.observe(configurator, {
      subtree: true,
      attributes: true,
      attributeFilter: ["data-image"],
    });
  }

  function revealPrice() {
    if (priceRevealed) return;
    priceRevealed = true;
    document.body.classList.add("digi-price-ready");
  }

  function revealGallery() {
    if (galleryRevealed) return;
    galleryRevealed = true;
    document.body.classList.add("digi-gallery-ready");
    document.querySelectorAll(".product__media-list").forEach(function (list) {
      list.classList.add("digi-loaded");
    });
  }

  function getExpectedPrice() {
    const variantId = parseInt(
      new URLSearchParams(window.location.search).get("variant"),
    );
    const variants = window.configProduct?.variants;
    if (!variants || !variantId) return null;
    return variants.find(function (v) {
      return v.id === variantId;
    });
  }

  function extractDigits(text) {
    return text.replace(/[^\d]/g, "");
  }

  function priceMatchesVariant(priceEl, variant) {
    if (!variant || !priceEl) return false;
    const domDigits = extractDigits(priceEl.textContent);
    const expectedDigits = String(variant.price);
    return domDigits.includes(expectedDigits);
  }

  function getExpectedGalleryImage() {
    const configurator = document.querySelector(".product-configurator");
    if (!configurator) return null;
    const firstZoom = configurator.querySelector(".image_zoom[data-image]");
    return firstZoom ? firstZoom.getAttribute("data-image") : null;
  }

  function galleryMatchesExpected(expectedSrc) {
    if (!expectedSrc) return false;
    var firstImg = document.querySelector(
      ".product__media-item .product__media > img",
    );
    if (!firstImg) return false;
    return (
      firstImg.src === expectedSrc ||
      firstImg.getAttribute("src") === expectedSrc
    );
  }

  function watchPrice(priceEl) {
    var observer = new MutationObserver(function () {
      var target = getExpectedPrice();
      if (priceMatchesVariant(priceEl, target)) {
        revealPrice();
        observer.disconnect();
      }
    });
    observer.observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    var target = getExpectedPrice();
    if (priceMatchesVariant(priceEl, target)) {
      revealPrice();
      observer.disconnect();
    }

    setTimeout(function () {
      revealPrice();
      observer.disconnect();
    }, 8000);
  }

  function watchGallery() {
    var expectedSrc = getExpectedGalleryImage();
    if (!expectedSrc) {
      revealGallery();
      return;
    }

    if (galleryMatchesExpected(expectedSrc)) {
      revealGallery();
      return;
    }

    var gallery = document.querySelector("media-gallery");
    if (!gallery) {
      revealGallery();
      return;
    }

    var observer = new MutationObserver(function () {
      if (galleryMatchesExpected(expectedSrc)) {
        revealGallery();
        observer.disconnect();
      }
    });
    observer.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src"],
    });

    setTimeout(function () {
      revealGallery();
      observer.disconnect();
    }, 8000);
  }

  window.addEventListener(
    "digi:variant-ready",
    function () {
      document.body.classList.add("digi-variant-ready");
      if (preloadObserver) preloadObserver.disconnect();

      var priceEl = document.querySelector('product-info > [id*="price-"]');
      if (!priceEl) {
        revealPrice();
      } else {
        watchPrice(priceEl);
      }

      watchGallery();
    },
    { once: true },
  );
})();

/* Domyślne warianty produktów */
(function () {
  const productMap = {
    // Mellven
    "lozko-mellven": { materialTechName: "legend", colorTechName: "legend-2" },
    "naroznik-mellven": {
      materialTechName: "legend",
      colorTechName: "legend-2",
      layout: "layout-2",
    },
    "sofa-mellven": { materialTechName: "legend", colorTechName: "legend-2" },
    "sofa-mini-mellven": {
      materialTechName: "legend",
      colorTechName: "legend-2",
    },
    "pufa-mellven": { materialTechName: "legend", colorTechName: "legend-2" },

    // Kloo
    "lozko-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "naroznik-kloo-duzy": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "naroznik-mini-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "sofa-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "sofa-mini-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "fotel-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "pufa-kloo": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },

    // Puffy
    "lozko-puffy": { materialTechName: "golden", colorTechName: "golden-21" },
    "naroznik-puffy": {
      materialTechName: "golden",
      colorTechName: "golden-21",
      layout: "layout-2",
    },
    "sofa-puffy": { materialTechName: "golden", colorTechName: "golden-21" },
    "fotel-puffy": { materialTechName: "golden", colorTechName: "golden-21" },
    "pufa-puffy": { materialTechName: "golden", colorTechName: "golden-21" },

    // Moodu
    "naroznik-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "naroznik-zestaw-1-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "naroznik-zestaw-2-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "naroznik-zestaw-3-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "naroznik-mini-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
      layout: "layout-2",
    },
    "sofa-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "sofa-mini-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "fotel-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "fotel-z-bokami-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },
    "pufa-moodu": {
      materialTechName: "landscape",
      colorTechName: "landscape-3",
    },

    // Cynthia
    "sofa-cynthia": {
      materialTechName: "landscape",
      colorTechName: "landscape-8",
    },
    "naroznik-cynthia": {
      materialTechName: "corbett",
      colorTechName: "corbett-23",
      layout: "layout-2",
    },

    // Monis
    "sofa-monis": { materialTechName: "legend", colorTechName: "legend-2" },
    "naroznik-monis": {
      materialTechName: "golden",
      colorTechName: "golden-3",
      layout: "layout-2",
    },

        // Solange
    "sofa-solange": { materialTechName: "golden", colorTechName: "golden-29" },

    // Gio
    "naroznik-gio": {
      materialTechName: "legend",
      colorTechName: "legend-2",
      layout: "layout-2",
    },
    "sofa-gio": { materialTechName: "legend", colorTechName: "legend-2" },
    "pufa-gio": { materialTechName: "legend", colorTechName: "legend-2" },

    //Suzanne
    "fotel-suzanne-z-obrotowa-podstawa": { materialTechName: "golden", colorTechName: "golden-29" }
  };

  let userChangedConfigurator = false;
  let isApplyingDefaultVariant = false;

  document.addEventListener(
    "click",
    function (e) {
      if (isApplyingDefaultVariant) return;

      const configuratorClick = e.target.closest(".product-configurator");
      if (!configuratorClick) return;

      userChangedConfigurator = true;
      console.log("digi user changed configurator");
    },
    true,
  );

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getCurrentVariantId() {
    const variantInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('product-form input[name="id"]') ||
      document.querySelector('.product-form input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (!variantInput || !variantInput.value) return null;

    return String(variantInput.value);
  }

  function normalizeValue(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");
  }

  function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const observer = new MutationObserver(() => {
        const found = document.querySelector(selector);
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        reject(`Element ${selector} not found within ${timeout}ms`);
      }, timeout);
    });
  }

  function getMaterialSection() {
    return document.querySelector(
      '.product-configurator [data-type="material"]',
    );
  }

  function getColorSection() {
    return document.querySelector('.product-configurator [data-type="color"]');
  }

  function getLayoutSection() {
    return document.querySelector('.product-configurator [data-type="layout"]');
  }

  function getMaterialInputByTechName(materialTechName) {
    if (!materialTechName) return null;

    const section = getMaterialSection();
    if (!section) return null;

    return (
      section.querySelector(`input[data-tech-name="${materialTechName}"]`) ||
      section.querySelector(`input[value="${materialTechName}"]`)
    );
  }

  function getColorInputByTechName(colorTechName) {
    if (!colorTechName) return null;

    const section = getColorSection();
    if (!section) return null;

    return (
      section.querySelector(`input[data-tech-name="${colorTechName}"]`) ||
      section.querySelector(`input[value="${colorTechName}"]`)
    );
  }

  function getMaterialClickableByTechName(materialTechName) {
    const input = getMaterialInputByTechName(materialTechName);
    if (!input) return null;

    const id = input.id;
    const section = getMaterialSection();

    const label =
      section?.querySelector(`label[for="${id}"]`) ||
      document.querySelector(
        `label.product-configurator__label[for="${id}"]`,
      ) ||
      document.querySelector(`label[for="${id}"]`);

    if (!label) return input;

    return (
      label.closest(".product-form__input-pill") ||
      label.closest(".product-configurator__label") ||
      label
    );
  }

  function getColorClickableByTechName(colorTechName) {
    const input = getColorInputByTechName(colorTechName);
    if (!input) return null;

    const id = input.id;
    const section = getColorSection();

    const label =
      section?.querySelector(`label[for="${id}"]`) ||
      document.querySelector(
        `label.product-configurator__label[for="${id}"]`,
      ) ||
      document.querySelector(`label[for="${id}"]`);

    if (!label) return input;

    return (
      label.closest(".product-form__input-pill") ||
      label.closest(".product-configurator__label") ||
      label
    );
  }

  function dispatchMouseSequence(el) {
    if (!el) return;

    ["pointerdown", "mousedown", "mouseup", "click"].forEach((eventName) => {
      el.dispatchEvent(
        new MouseEvent(eventName, {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
    });
  }

  function clickMaterialByTechName(materialTechName) {
    const input = getMaterialInputByTechName(materialTechName);
    const clickable = getMaterialClickableByTechName(materialTechName);

    if (!input || !clickable) return false;

    dispatchMouseSequence(clickable);

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return true;
  }

  function clickColorByTechName(colorTechName) {
    const input = getColorInputByTechName(colorTechName);
    const clickable = getColorClickableByTechName(colorTechName);

    if (!input || !clickable) return false;

    dispatchMouseSequence(clickable);

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return true;
  }

  function clickLabelByFor(value) {
    if (!value) return false;

    const label = document.querySelector(
      `label.product-configurator__label[for="${value}"]`,
    );

    if (!label) return false;

    dispatchMouseSequence(label);
    return true;
  }

  function waitForMaterialByTechName(materialTechName, timeout = 7000) {
    return new Promise((resolve, reject) => {
      const existing = getMaterialInputByTechName(materialTechName);
      if (existing) return resolve(existing);

      const observer = new MutationObserver(() => {
        const found = getMaterialInputByTechName(materialTechName);
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        reject(`Material ${materialTechName} not found within ${timeout}ms`);
      }, timeout);
    });
  }

  function waitForColorByTechName(colorTechName, timeout = 7000) {
    return new Promise((resolve, reject) => {
      const existing = getColorInputByTechName(colorTechName);
      if (existing) return resolve(existing);

      const observer = new MutationObserver(() => {
        const found = getColorInputByTechName(colorTechName);
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        reject(`Color ${colorTechName} not found within ${timeout}ms`);
      }, timeout);
    });
  }

  function getCheckedMaterial() {
    const section = getMaterialSection();
    return section?.querySelector('input[type="radio"]:checked') || null;
  }

  function getCheckedColor() {
    const section = getColorSection();
    return section?.querySelector('input[type="radio"]:checked') || null;
  }

  function getCheckedLayout() {
    const section = getLayoutSection();

    return (
      section?.querySelector('input[type="radio"]:checked') ||
      (layout
        ? document.querySelector(`.product-configurator input[id="${layout}"]`)
        : null)
    );
  }

  async function forceSelectMaterial(materialTechName, attempts = 5) {
    for (let i = 0; i < attempts; i++) {
      clickMaterialByTechName(materialTechName);
      await wait(350);

      const checked = getCheckedMaterial();
      if (
        checked &&
        (checked.dataset.techName === materialTechName ||
          checked.value === materialTechName)
      ) {
        return true;
      }
    }

    return false;
  }

  async function forceSelectColor(colorTechName, attempts = 5) {
    for (let i = 0; i < attempts; i++) {
      clickColorByTechName(colorTechName);
      await wait(400);

      const checked = getCheckedColor();
      if (
        checked &&
        (checked.dataset.techName === colorTechName ||
          checked.value === colorTechName)
      ) {
        return true;
      }
    }

    return false;
  }

  function getSelectedConfiguratorValues() {
    const material = getCheckedMaterial();
    const color = getCheckedColor();
    const layoutInput = getCheckedLayout();

    return {
      material:
        material?.dataset.techName ||
        material?.value ||
        materialTechName ||
        null,

      color: color?.dataset.techName || color?.value || colorTechName || null,

      layout:
        layoutInput?.value || layoutInput?.dataset.techName || layout || null,
    };
  }

  function variantMatchesSelectedConfig(variant, selected) {
    if (!variant || !selected) return false;

    const values = [
      variant.option1,
      variant.option2,
      variant.option3,
      ...(Array.isArray(variant.options) ? variant.options : []),
      variant.title,
    ]
      .filter(Boolean)
      .map(normalizeValue);

    const material = normalizeValue(selected.material);
    const color = normalizeValue(selected.color);
    const layoutValue = normalizeValue(selected.layout);

    const materialMatches =
      !material || values.some((v) => v.includes(material));
    const colorMatches = !color || values.some((v) => v.includes(color));

    const layoutMatches =
      !layoutValue ||
      layoutValue === "layout-2" ||
      values.some((v) => v.includes(layoutValue)) ||
      values.some((v) => v.includes("prawa"));

    return materialMatches && colorMatches && layoutMatches;
  }

  function findExpectedVariantId() {
    const variants = window.configProduct?.variants;
    if (!Array.isArray(variants)) return null;

    const selected = getSelectedConfiguratorValues();

    const matchedVariant = variants.find((variant) =>
      variantMatchesSelectedConfig(variant, selected),
    );

    if (!matchedVariant) {
      console.warn("Nie znaleziono wariantu dla konfiguracji:", selected);
      return null;
    }

    return String(matchedVariant.id);
  }

  function forceProductFormVariantId(variantId) {
    if (!variantId) return false;

    const inputs = document.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"], product-form input[name="id"], .product-form input[name="id"], input[name="id"]',
    );

    if (!inputs.length) {
      console.warn("Nie znaleziono input[name='id'] do aktualizacji wariantu");
      return false;
    }

    inputs.forEach((input) => {
      input.value = variantId;
      input.setAttribute("value", variantId);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    console.log("digi forced product form variant id:", variantId);

    return true;
  }

  function getSelectedParamValue(type, fallbackValue = null) {
    const section = document.querySelector(
      `.product-configurator [data-type="${type}"]`,
    );

    const checked = section?.querySelector('input[type="radio"]:checked');

    if (!checked) return fallbackValue;

    if (type === "layout") {
      return checked.value || checked.dataset.techName || fallbackValue;
    }

    return checked.dataset.techName || checked.value || fallbackValue;
  }

  function getLayoutParamValue(layoutFallback = null) {
    const checkedLayout =
      document.querySelector(
        '.product-configurator [data-type="layout"] input[type="radio"]:checked',
      ) ||
      document.querySelector(
        `.product-configurator input[id="${layoutFallback}"]`,
      );

    if (!checkedLayout) return null;

    return (
      checkedLayout.value || checkedLayout.dataset.techName || layoutFallback
    );
  }

  function updateUrlVariant(variantId) {
    const url = new URL(window.location.href);

    const materialParam = getSelectedParamValue("material", materialTechName);
    const colorParam = getSelectedParamValue("color", colorTechName);
    const layoutParam = getLayoutParamValue(layout);

    if (materialParam) {
      url.searchParams.set("material", materialParam);
    }

    if (colorParam) {
      url.searchParams.set("color", colorParam);
    }

    if (layoutParam) {
      url.searchParams.set("layout", layoutParam);
    }

    if (variantId) {
      url.searchParams.set("variant", variantId);
    }

    window.history.replaceState({}, "", url.toString());

    return true;
  }

  function syncExpectedVariantToFormAndUrl() {
    if (userChangedConfigurator) {
      console.log("digi skip default sync - user changed configurator");
      return null;
    }

    const expectedVariantId = findExpectedVariantId() || getCurrentVariantId();

    if (!expectedVariantId) {
      console.warn("Nie udało się ustalić expectedVariantId");
      return null;
    }

    forceProductFormVariantId(expectedVariantId);
    updateUrlVariant(expectedVariantId);

    console.log("digi expected variant synced:", expectedVariantId);
    console.log("digi selected config:", getSelectedConfiguratorValues());
    console.log("digi url after expected sync:", window.location.href);

    return expectedVariantId;
  }

  async function waitForVariantUrlSync(timeout = 6000) {
    const start = Date.now();
    let lastVariantId = null;
    let stableCount = 0;

    return new Promise((resolve) => {
      const check = () => {
        const variantId = getCurrentVariantId();

        if (variantId) {
          if (variantId === lastVariantId) {
            stableCount += 1;
          } else {
            lastVariantId = variantId;
            stableCount = 1;
          }

          if (stableCount >= 3) {
            updateUrlVariant(variantId);
            resolve(variantId);
            return;
          }
        }

        if (Date.now() - start >= timeout) {
          if (lastVariantId) {
            updateUrlVariant(lastVariantId);
            resolve(lastVariantId);
          } else {
            resolve(null);
          }
          return;
        }

        setTimeout(check, 150);
      };

      check();
    });
  }

  const handle = window.configProduct?.handle;
  const variant = handle ? productMap[handle] : null;

  const urlParams = new URLSearchParams(window.location.search);
  const hasSharedConfig =
    urlParams.has("material") ||
    urlParams.has("color") ||
    urlParams.has("layout");

  if (hasSharedConfig) {
    console.log(
      "digi shared-link config detected - skipping default variant force",
    );
    userChangedConfigurator = true;
    document.body.classList.add("digi-price-ready");
    document.body.classList.add("digi-gallery-ready");
    window.dispatchEvent(new CustomEvent("digi:variant-ready"));
    return;
  }

  console.log("digi default variant handle:", handle);
  console.log("digi default variant config:", variant);

  if (!variant) {
    console.warn("Brak zmapowanego handle:", handle);
    document.body.classList.add("digi-price-ready");
    document.body.classList.add("digi-gallery-ready");
    window.dispatchEvent(new CustomEvent("digi:variant-ready"));
    return;
  }

  const { materialTechName, colorTechName, layout } = variant;

  const firstSelector = materialTechName
    ? `.product-configurator [data-type="material"] input[data-tech-name="${materialTechName}"], .product-configurator [data-type="material"] input[value="${materialTechName}"]`
    : colorTechName
      ? `.product-configurator [data-type="color"] input[data-tech-name="${colorTechName}"], .product-configurator [data-type="color"] input[value="${colorTechName}"]`
      : layout
        ? `label.product-configurator__label[for="${layout}"]`
        : null;

  if (!firstSelector) {
    window.dispatchEvent(new CustomEvent("digi:variant-ready"));
    return;
  }

  waitForElement(firstSelector)
    .then(async () => {
      isApplyingDefaultVariant = true;

      if (materialTechName) {
        try {
          await waitForMaterialByTechName(materialTechName, 7000);

          console.log(
            "Klikam materiał techname:",
            materialTechName,
            getMaterialInputByTechName(materialTechName),
            getMaterialClickableByTechName(materialTechName),
          );

          const materialSelected = await forceSelectMaterial(
            materialTechName,
            5,
          );

          console.log("material selected:", materialSelected);
          console.log("checked material after click:", getCheckedMaterial());

          await wait(700);
        } catch (err) {
          console.warn(err);
        }
      }

      if (colorTechName) {
        try {
          await waitForColorByTechName(colorTechName, 7000);

          console.log(
            "Klikam kolor techname:",
            colorTechName,
            getColorInputByTechName(colorTechName),
            getColorClickableByTechName(colorTechName),
          );

          const colorSelected = await forceSelectColor(colorTechName, 5);

          console.log("color selected:", colorSelected);
          console.log("checked color after click:", getCheckedColor());

          await wait(900);
        } catch (err) {
          console.warn(err);
        }
      }

      if (layout) {
        try {
          await waitForElement(
            `label.product-configurator__label[for="${layout}"]`,
            5000,
          );
          console.log("Klikam layout:", layout);
          clickLabelByFor(layout);
          await wait(500);
        } catch (err) {
          console.warn(err);
        }
      }

      isApplyingDefaultVariant = false;
    })
    .catch((err) => {
      isApplyingDefaultVariant = false;
      console.warn(err);
    })
    .finally(async () => {
      await wait(900);

      syncExpectedVariantToFormAndUrl();

      setTimeout(() => {
        syncExpectedVariantToFormAndUrl();
        console.log(
          "digi current url after delayed sync 1:",
          window.location.href,
        );
      }, 500);

      setTimeout(() => {
        syncExpectedVariantToFormAndUrl();
        console.log(
          "digi current url after delayed sync 2:",
          window.location.href,
        );
      }, 1500);

      window.dispatchEvent(new CustomEvent("digi:variant-ready"));
    });
})();

function digiGetCheckedConfiguratorInput(type) {
  const section = document.querySelector(
    `.product-configurator [data-type="${type}"]`,
  );

  if (!section) return null;

  return section.querySelector('input[type="radio"]:checked');
}

function digiGetInputLabelText(input) {
  if (!input) return "";

  const label =
    document.querySelector(`label[for="${input.id}"]`) ||
    input.closest(".product-form__input-pill")?.querySelector("label") ||
    input.closest(".product-configurator__label");

  if (!label) return input.value || input.dataset.techName || "";

  return label.textContent.replace(/\s+/g, " ").trim();
}

function digiGetCurrentCartProperties() {
  const materialInput = digiGetCheckedConfiguratorInput("material");
  const colorInput = digiGetCheckedConfiguratorInput("color");
  const layoutInput = digiGetCheckedConfiguratorInput("layout");

  const materialText = digiGetInputLabelText(materialInput);
  const colorText = digiGetInputLabelText(colorInput);
  const layoutText = digiGetInputLabelText(layoutInput);

  const visibleColorParam = document.querySelector(
    '.product__params__param[data-name="Kolor"]',
  );

  const visibleLayoutParam = document.querySelector(
    '.product__params__param[data-name="Strona"]',
  );

  let colorFromVisible = "";
  if (visibleColorParam) {
    colorFromVisible = visibleColorParam.textContent
      .replace("Kolor:", "")
      .replace(/\s+/g, " ")
      .trim();
  }

  let layoutFromVisible = "";
  if (visibleLayoutParam) {
    layoutFromVisible = visibleLayoutParam.textContent
      .replace("Strona:", "")
      .replace(/\s+/g, " ")
      .trim();
  }

  return {
    material: materialText,
    color: colorFromVisible || colorText,
    layout: layoutFromVisible || layoutText,
  };
}

function digiSetCartProperty(form, name, value) {
  if (!form || !name || !value) return;

  let input = form.querySelector(`input[name="properties[${name}]"]`);

  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${name}]`;
    form.appendChild(input);
  }

  input.value = value;
  input.setAttribute("value", value);

  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(new Event("change", { bubbles: true }));
}

function digiSyncCurrentConfigToCartForm() {
  const forms = document.querySelectorAll('form[action*="/cart/add"]');

  if (!forms.length) {
    console.warn("digi: nie znaleziono formularza /cart/add");
    return false;
  }

  const props = digiGetCurrentCartProperties();

  forms.forEach((form) => {
    if (props.material) {
      digiSetCartProperty(form, "Kolekcja tkanin", props.material);
    }

    if (props.color) {
      digiSetCartProperty(form, "Kolor", props.color);
    }

    if (props.layout) {
      digiSetCartProperty(form, "Strona", props.layout);
    }
  });

  console.log("digi synced cart properties:", props);

  return true;
}

document.addEventListener(
  "submit",
  function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    digiSyncCurrentConfigToCartForm();
  },
  true,
);

document.addEventListener(
  "click",
  function (e) {
    const addToCartBtn = e.target.closest(
      '.product-form__submit, button[name="add"], [type="submit"]',
    );

    if (!addToCartBtn) return;

    const form = addToCartBtn.closest('form[action*="/cart/add"]');

    if (!form && !addToCartBtn.closest(".product-form__buttons")) return;

    digiSyncCurrentConfigToCartForm();
  },
  true,
);

/* Sticky bar z nazwą, ceną i przyciskami */
(function () {
  let stickyInitialized = false;

  const selectors = {
    title: ".product__title > h1",
    priceParent: ".product__info-container",
    price: ".product__info-container > .no-js-hidden .price__container",
    configuratorBtn: ".button--configurator",
    addToCartBtn: ".product-form__buttons .product-form__submit",
  };

  function getElements() {
    return {
      titleEl: document.querySelector(selectors.title),
      priceParentEl: document.querySelector(selectors.priceParent),
      configuratorEl: document.querySelector(selectors.configuratorBtn),
      addToCartEl: document.querySelector(selectors.addToCartBtn),
      stickyPriceEl: document.querySelector(
        ".digi-sticky-btn-container .price",
      ),
    };
  }

  function allExist(els) {
    return (
      els.titleEl && els.priceParentEl && els.configuratorEl && els.addToCartEl
    );
  }

  function createStickyBar() {
    if (stickyInitialized) return;

    const els = getElements();
    if (!allExist(els)) return;

    stickyInitialized = true;

    const container = document.createElement("div");
    container.className = "digi-sticky-btn-container";
    container.innerHTML = `
          <div class="title">${els.titleEl.textContent.trim()}</div>
          <div class="price">${document.querySelector(selectors.price)?.innerHTML.trim() || ""}</div>
          <button id="digi-config-product">${window.digiI18n.configurator.configure}</button>
          <button id="digi-add-to-cart">${window.variantStrings.addToCart}</button>
        `;
    document.body.appendChild(container);

    const stickyPriceEl = container.querySelector(".price");

    container
      .querySelector("#digi-config-product")
      .addEventListener("click", () => els.configuratorEl.click());
    container
      .querySelector("#digi-add-to-cart")
      .addEventListener("click", () => {
        if (typeof digiSyncCurrentConfigToCartForm === "function") {
          digiSyncCurrentConfigToCartForm();
        }

        setTimeout(() => {
          els.addToCartEl.click();
        }, 100);
      });

    const priceObserver = new MutationObserver(() => {
      const currentPrice = document.querySelector(selectors.price);
      if (currentPrice) stickyPriceEl.innerHTML = currentPrice.innerHTML.trim();
    });
    priceObserver.observe(els.priceParentEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  createStickyBar();

  const globalObserver = new MutationObserver(() => {
    createStickyBar();
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });

  function updateFloatingElements(active) {
    const selectors = [
      ".thulium-chat-frame-wrapper",
      "#CookiebotWidget",
      'button[data-testid="minimized-trustbadge-floating"]',
    ];

    selectors.forEach((sel) => {
      let el = document.querySelector(sel);
      if (!el) return;
      if (sel.includes("minimized-trustbadge")) {
        el = el.parentElement;
        if (!el) return;
      }
      el.style.transition = "transform 0.2s";
      el.style.setProperty(
        "transform",
        active ? "translateY(-73px)" : "translateY(0)",
        "important",
      );
    });
  }

  const btnSection = document.querySelector(".product-form__buy-buttons");
  if (btnSection) {
    const handleScroll = () => {
      const stickyBar = document.querySelector(".digi-sticky-btn-container");
      if (!stickyBar) return;

      const btnBottom = btnSection.getBoundingClientRect().bottom;
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 2;

      if (btnBottom < 0 && !scrolledToBottom) {
        stickyBar.classList.add("active");
        updateFloatingElements(true);
      } else {
        stickyBar.classList.remove("active");
        updateFloatingElements(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  }
})();

/* Show video btn */
const customTranslatorKeys = window.digiI18n?.custom || {};
const showVideoLabel = customTranslatorKeys.show_video || "Zobacz video";

const galleries = document.querySelectorAll("media-gallery");
galleries.forEach((gallery) => {
  const videos = gallery.querySelectorAll(
    ".product-media-container.media-type-video",
  );
  if (videos.length === 0) return;

  const videoSlide = videos[videos.length - 1];
  if (!videoSlide) return;
  const wrapper = videoSlide.closest(".product__media-wrapper");
  if (!wrapper) return;

  const ul = wrapper.querySelector("ul");
  if (!ul) return;

  const firstLi = ul.querySelector("li");
  if (!firstLi) return;

  if (firstLi.querySelector(".digi-show-video")) return;

  const btn = document.createElement("button");
  btn.className = "digi-show-video";
  btn.innerHTML = `
            <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M7.25 13.5385L13.5385 9.5L7.25 5.4615V13.5385ZM9.50175 19C8.18775 19 6.95267 18.7507 5.7965 18.252C4.64033 17.7533 3.63467 17.0766 2.7795 16.2218C1.92433 15.3669 1.24725 14.3617 0.74825 13.206C0.249417 12.0503 0 10.8156 0 9.50175C0 8.18775 0.249333 6.95267 0.748 5.7965C1.24667 4.64033 1.92342 3.63467 2.77825 2.7795C3.63308 1.92433 4.63833 1.24725 5.794 0.74825C6.94967 0.249417 8.18442 0 9.49825 0C10.8123 0 12.0473 0.249333 13.2035 0.748C14.3597 1.24667 15.3653 1.92342 16.2205 2.77825C17.0757 3.63308 17.7528 4.63833 18.2518 5.794C18.7506 6.94967 19 8.18442 19 9.49825C19 10.8123 18.7507 12.0473 18.252 13.2035C17.7533 14.3597 17.0766 15.3653 16.2218 16.2205C15.3669 17.0757 14.3617 17.7528 13.206 18.2518C12.0503 18.7506 10.8156 19 9.50175 19ZM9.5 17.5C11.7333 17.5 13.625 16.725 15.175 15.175C16.725 13.625 17.5 11.7333 17.5 9.5C17.5 7.26667 16.725 5.375 15.175 3.825C13.625 2.275 11.7333 1.5 9.5 1.5C7.26667 1.5 5.375 2.275 3.825 3.825C2.275 5.375 1.5 7.26667 1.5 9.5C1.5 11.7333 2.275 13.625 3.825 15.175C5.375 16.725 7.26667 17.5 9.5 17.5Z" fill="#656363"/>
                </svg>
            </div>
            <span>${showVideoLabel}</span>
        `;

  firstLi.appendChild(btn);

  btn.addEventListener("click", () => {
    document
      .querySelectorAll(".product__media-list__trigger")
      .forEach((btn) => btn.click());
    const videoUrl = getVideoUrlFromConfigProduct();
    console.log("videoUrl", videoUrl);
    if (videoUrl) {
      openVideoPopup(videoUrl);
    } else {
      console.warn("Brak video w window.configProduct");
    }
  });
});

function getVideoUrlFromConfigProduct() {
  if (!window.configProduct || !Array.isArray(window.configProduct.media))
    return null;

  const videoMedia = window.configProduct.media.find(
    (media) => media.media_type === "video" && Array.isArray(media.sources),
  );
  if (!videoMedia) return null;

  const mp4Sources = videoMedia.sources.filter(
    (source) => source.format === "mp4" && source.url,
  );
  if (!mp4Sources.length) return null;
  mp4Sources.sort((a, b) => (b.height || 0) - (a.height || 0));
  return mp4Sources[0].url;
}

function openVideoPopup(videoUrl) {
  if (!videoUrl) return;

  let popup = document.querySelector("#digi-video-popup");
  if (!popup) {
    popup = document.createElement("div");
    popup.id = "digi-video-popup";
    popup.innerHTML = `
                <div class="digi-video-backdrop"></div>
                <div class="digi-video-modal">
                    <button class="digi-video-close" aria-label="Zamknij">&times;</button>
                    <video controls autoplay playsinline></video>
                </div>
            `;
    document.body.appendChild(popup);
    popup
      .querySelector(".digi-video-close")
      .addEventListener("click", closeVideoPopup);
    popup
      .querySelector(".digi-video-backdrop")
      .addEventListener("click", closeVideoPopup);
  }

  const video = popup.querySelector("video");
  video.src = videoUrl;
  video.load();
  popup.classList.add("is-visible");
  lockScroll();
}

function closeVideoPopup() {
  const popup = document.querySelector("#digi-video-popup");
  if (!popup) return;
  const video = popup.querySelector("video");
  video.pause();
  video.src = "";
  popup.classList.remove("is-visible");
  unlockScroll();
}

function lockScroll() {
  document.body.classList.add("digi-no-scroll");
}
function unlockScroll() {
  document.body.classList.remove("digi-no-scroll");
}

function refactorProductParams(params) {
  const configTranslatorKeys = window.digiI18n?.configurator || {};

  if (!params.querySelector(".product__params__header")) {
    const header = document.createElement("div");
    header.className = "product__params__header";
    header.innerHTML = `
                <span>${configTranslatorKeys.currentConfiguration}</span>
                <span id="current-config-tooltip" class="digi-tooltip">${configTranslatorKeys.tooltip.whatCanIChange}</span>
            `;
    params.prepend(header);
  }

  let configButton = params.querySelector(".product__params__button");
  if (!configButton) {
    configButton = document.createElement("button");
    configButton.className = "product__params__button";
    configButton.textContent = configTranslatorKeys.configure;
    configButton.addEventListener("click", () => {
      const formButton = document.querySelector(
        ".product-form__configurator .button",
      );
      if (formButton) formButton.click();
    });
    params.append(configButton);
  }

  const colorParam = params.querySelector(
    '.product__params__param[data-name="Kolor"]',
  );
  if (colorParam && !params.querySelector(".digi-colors")) {
    const activeColorSpan = colorParam.querySelector(
      ".product-configurator__label__color",
    );

    const colorsWrapper = document.createElement("ul");
    colorsWrapper.className =
      "colors-switcher list-menu small-down-none digi-colors";
    colorsWrapper.innerHTML = `
                <li class="colors-switcher__item">
                    <img src="//mittohome.pl/cdn/shop/files/boni-02-1024x1024.jpg?crop=center&height=24&v=1748883919&width=24">
                </li>
                <li class="colors-switcher__item">
                    <img src="//mittohome.pl/cdn/shop/files/hartman-05-1024x1024.jpg?crop=center&height=24&v=1742202181&width=24">
                </li>
                <li class="colors-switcher__item active-color"></li>
                <li class="colors-switcher__item">
                    <img src="//mittohome.pl/cdn/shop/files/legend-4.jpg?crop=center&height=24&v=1740480793&width=24">
                </li>
                <li class="colors-switcher__item">
                    <img src="//mittohome.pl/cdn/shop/files/melody-13_bb690709-cf07-48a5-9ee0-8a8a1d901089.jpg?crop=center&height=24&v=1740480821&width=24">
                </li>
                <li class="colors-switcher__item last">
                    <div class="colors-switcher__more">+ 20 ${configTranslatorKeys.colors.more_count}</div>
                </li>
            `;

    if (activeColorSpan) {
      const activeSlot = colorsWrapper.querySelector(".active-color");
      activeSlot.appendChild(activeColorSpan.cloneNode(true));
      activeColorSpan.style.display = "none";
    }

    colorsWrapper.addEventListener("click", () => configButton.click());
    colorParam.after(colorsWrapper);
  }

  if (tippy) {
    const prodConfigSelector = document.querySelector(".product-configurator");
    if (!prodConfigSelector) return;

    const prodConfigElements = prodConfigSelector.querySelectorAll(
      "[data-type][data-name]:not(.hidden)",
    );
    if (!prodConfigElements?.length) return;

    const dataType__labels = {
      SLEEP_SIZE: configTranslatorKeys.tooltip.labels.sleep_size,
      SLEEP_FUNCTION: configTranslatorKeys.tooltip.labels.sleep_function,
      MATERAC: configTranslatorKeys.tooltip.labels.materac,
      MATTRESS: configTranslatorKeys.tooltip.labels.mattress,
      MATERIAL: configTranslatorKeys.tooltip.labels.material,
      COLOR: configTranslatorKeys.tooltip.labels.color,
      LAYOUT: configTranslatorKeys.tooltip.labels.layout,
      PILLOW_FILLING_TYPE:
        configTranslatorKeys.tooltip.labels.pillow_filling_type,
      CINEMA_FUNCTION: configTranslatorKeys.tooltip.labels.cinema_function,
      WIDTH: configTranslatorKeys.tooltip.labels.width,
    };
    const dataType__aliases = {
      "powierzchnia-spania": "SLEEP_SIZE",
      "funkcja-spania": "SLEEP_FUNCTION",
      materac: "MATERAC",
      mattress: "MATTRESS",
      material: "MATERIAL",
      color: "COLOR",
      layout: "LAYOUT",
      "rodzaj-wypelnienia-poduszek": "PILLOW_FILLING_TYPE",
      "funkcja-kinowa": "CINEMA_FUNCTION",
      szerokosc: "WIDTH",
    };

    const getLabel = (type) => {
      const key = dataType__aliases[type?.toLowerCase()];
      return dataType__labels[key] ?? null;
    };

    const tooltip_content = [];
    prodConfigElements.forEach((configEl) => {
      const labelText = getLabel(configEl.dataset.type);
      if (!labelText) return;
      tooltip_content.push(`<li>${labelText}</li>`);
    });

    tippy("#current-config-tooltip", {
      content: `
          <p>${configTranslatorKeys.tooltip.you_can}:</p>
          <ul>
              ${tooltip_content.join("")}
          </ul>
      `,
      allowHTML: true,
    });


  }
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches(".product__params")) {
          refactorProductParams(node);
        }
      });
    }
    if (mutation.type === "childList" || mutation.type === "subtree") {
      const params = mutation.target.closest(".product__params");
      if (params) refactorProductParams(params);
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });

/* Inne modele slider */
function initEmblaSlider(containerSelector, slideClass) {
  const container = document.querySelector(containerSelector);
  if (!container || !container.children.length) return;

  const viewport = document.createElement("div");
  viewport.className = "embla__viewport";

  const wrapper = document.createElement("div");
  wrapper.className = "embla__container";

  while (container.firstChild) {
    const slide = container.firstChild;
    if (slide.classList && slide.classList.contains(slideClass)) {
      slide.classList.add("embla__slide");
      wrapper.appendChild(slide);
    } else {
      container.removeChild(slide);
    }
  }

  viewport.appendChild(wrapper);
  container.appendChild(viewport);

  const controls = document.createElement("div");
  controls.className = "embla__controls";
  container.appendChild(controls);

  const prevBtn = document.createElement("button");
  prevBtn.className = "embla__prev";
  controls.appendChild(prevBtn);

  const dots = document.createElement("div");
  dots.className = "embla__dots";
  controls.appendChild(dots);

  const nextBtn = document.createElement("button");
  nextBtn.className = "embla__next";
  controls.appendChild(nextBtn);

  const embla = EmblaCarousel(viewport, {
    loop: false,
    align: "start",
    draggable: true,
    containScroll: "trimSnaps",
    slidesToScroll: "auto"
  });

  const slides = Array.from(wrapper.children);

  const createDots = () => {
    if (!dots) return;

    dots.innerHTML = "";

    embla.scrollSnapList().forEach((_, index) => {
      const dot = document.createElement("button");

      dot.type = "button";
      dot.className = "embla__dot";
      dot.setAttribute("aria-label", `Przejdź do strony ${index + 1}`);

      dot.addEventListener("click", () => embla.scrollTo(index));

      dots.appendChild(dot);
    });
  };

  const updateSelectedDot = () => {
    if (!dots) return;

    const selectedIndex = embla.selectedScrollSnap();

    dots.querySelectorAll(".embla__dot").forEach((dot, idx) => {
      dot.classList.toggle("is-selected", idx === selectedIndex);
    });
  };

  const updateDots = () => {
    createDots();
    updateSelectedDot();

    if (dots) {
      dots.style.display = embla.scrollSnapList().length > 1 ? "" : "none";
    }
  };

  updateDots();

  nextBtn?.addEventListener("click", () => embla.scrollNext());
  prevBtn?.addEventListener("click", () => embla.scrollPrev());

  embla.on("select", updateSelectedDot);
  embla.on("reInit", updateDots);

  window.addEventListener("resize", () => {
    embla.reInit();
    updateDots();
  });

  container.classList.add("embla-slider-initializated");
}

initEmblaSlider(".related-products", "related-product");
initEmblaSlider(".recommended-accessories", "accessory-wrap");

/* Tooltips */
$(document).ready(function () {
  function unescapeHtml(s) {
    const el = document.createElement("textarea");
    el.innerHTML = s;
    return el.value;
  }

  const tooltipIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M6.61111 10.5H7.38889V6.22222H6.61111V10.5ZM7 5.11545C7.13559 5.11545 7.24928 5.06956 7.34106 4.97778C7.43283 4.886 7.47872 4.77232 7.47872 4.63672C7.47872 4.50113 7.43283 4.38744 7.34106 4.29567C7.24928 4.20402 7.13559 4.15819 7 4.15819C6.86441 4.15819 6.75072 4.20402 6.65894 4.29567C6.56717 4.38744 6.52128 4.50113 6.52128 4.63672C6.52128 4.77232 6.56717 4.886 6.65894 4.97778C6.75072 5.06956 6.86441 5.11545 7 5.11545ZM7.00253 14C6.03458 14 5.12452 13.8163 4.27233 13.4489C3.42028 13.0816 2.67906 12.583 2.04867 11.9533C1.41828 11.3235 0.919268 10.583 0.551639 9.73156C0.18388 8.88028 0 7.9706 0 7.00253C0 6.03458 0.183685 5.12452 0.551055 4.27233C0.918426 3.42028 1.41698 2.67906 2.04672 2.04867C2.67646 1.41828 3.41704 0.919268 4.26844 0.551639C5.11972 0.18388 6.0294 0 6.99747 0C7.96542 0 8.87548 0.183686 9.72767 0.551056C10.5797 0.918426 11.3209 1.41698 11.9513 2.04672C12.5817 2.67646 13.0807 3.41704 13.4484 4.26845C13.8161 5.11972 14 6.0294 14 6.99747C14 7.96542 13.8163 8.87548 13.4489 9.72767C13.0816 10.5797 12.583 11.3209 11.9533 11.9513C11.3235 12.5817 10.583 13.0807 9.73156 13.4484C8.88028 13.8161 7.9706 14 7.00253 14ZM7 13.2222C8.73704 13.2222 10.2083 12.6194 11.4139 11.4139C12.6194 10.2083 13.2222 8.73704 13.2222 7C13.2222 5.26296 12.6194 3.79167 11.4139 2.58611C10.2083 1.38056 8.73704 0.777778 7 0.777778C5.26296 0.777778 3.79167 1.38056 2.58611 2.58611C1.38056 3.79167 0.777778 5.26296 0.777778 7C0.777778 8.73704 1.38056 10.2083 2.58611 11.4139C3.79167 12.6194 5.26296 13.2222 7 13.2222Z" fill="#656363"/>
            </svg>
        `;

  if ($(".product__info-container .product__delivery").length) {
    $(".product__info-container .product__delivery").append(`
                <span id="delivery-tooltip" class="digi-tooltip">${tooltipIcon}</span>
            `);
  }

  if ($("#service-usp").length) {
    $("#service-usp").append(`
                <span id="service-tooltip" class="digi-tooltip">${tooltipIcon}</span>
            `);
  }

  if ($(".digi-ups-block-item[data-returnable][data-tooltip-copy]").length) {
    $(".digi-ups-block-item[data-returnable][data-tooltip-copy]").append(`
        <span id="returnable-tooltip" class="digi-tooltip">${tooltipIcon}</span>
    `);

    const copy = unescapeHtml(document.querySelector('.digi-ups-block-item[data-returnable][data-tooltip-copy]').dataset.tooltipCopy.trim());
    if( copy ) {
      tippy("#returnable-tooltip", { content: copy, allowHTML: true });
    };
  };

  const makeTime = window.digiProductMakeTime;
  if (makeTime) {
    const deliveryTranslatorKeys = window.digiI18n?.delivery || {};
    const temp = deliveryTranslatorKeys.tooltip.lead_time_info;
    let ctn = temp
      .replace("{{ production_min }}", makeTime.minimum)
      .replace("{{ production_max }}", makeTime.maximum)
      .replace("{{ delivery_days }}", makeTime.delivery);
    ctn = unescapeHtml(ctn);
    tippy("#delivery-tooltip", { content: ctn, allowHTML: true });
  }

  if (true) {
    const serviceTranslatorKeys = window.digiI18n?.service || {};
    const temp = serviceTranslatorKeys.tooltip.installation_and_carry_info;
    let ctn = unescapeHtml(temp);
    tippy("#service-tooltip", { content: ctn, allowHTML: true });
  }
});

/* Replace main gallery with config images */
function updateMediaGallery() {
  const configurator = document.querySelector(".product-configurator");
  if (!configurator) {
    if (document.body.classList.contains("digi-gallery-ready")) {
      document
        .querySelectorAll(".product__media-list")
        .forEach((list) => list.classList.add("digi-loaded"));
    }
    return;
  }

  const imageZooms = configurator.querySelectorAll(".image_zoom[data-image]");
  const images = Array.from(imageZooms)
    .slice(0, 3)
    .map((img) => img.getAttribute("data-image"));

  const mediaGalleries = document.querySelectorAll("media-gallery");
  if (!mediaGalleries) {
    if (document.body.classList.contains("digi-gallery-ready")) {
      document
        .querySelectorAll(".product__media-list")
        .forEach((list) => list.classList.add("digi-loaded"));
    }
    return;
  }

  mediaGalleries.forEach((mediaGallery) => {
    const mediaItems = mediaGallery.querySelectorAll(
      ".product__media-item .product__media > img",
    );

    mediaItems.forEach((img, index) => {
      const mediaItem = img.closest(".product__media-item");

      const video = mediaItem.querySelector(".product__media__video");
      if (video) {
        video.remove();
        const modalOpener = mediaItem.querySelector("modal-opener");
        if (modalOpener) modalOpener.style.opacity = "1";
      }

      if (images[index]) {
        img.src = images[index];
        img.srcset = images[index];
        img.sizes = "";
        img.style.position = "relative";
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.top = "unset";
        img.style.right = "unset";
        img.style.transform = "none";
        const parent = img.parentElement;
        if (parent) parent.style.padding = "0";
      }
    });
  });

  const modalItems = document.querySelectorAll(".product-media-modal__item");
  modalItems.forEach((item, index) => {
    if (index >= 3) return;
    const newImageUrl = images[index];
    if (!newImageUrl) return;

    const zoomBox = item.querySelector(".image_zoom__box");
    if (zoomBox) zoomBox.style.backgroundImage = `url("${newImageUrl}")`;

    let container = item.querySelector(".digi-replaced-img");
    if (!container) {
      container = document.createElement("div");
      container.className = "digi-replaced-img";
      const img = document.createElement("img");
      img.src = newImageUrl;
      container.appendChild(img);
      item.appendChild(container);
    } else {
      const img = container.querySelector("img");
      if (img) {
        img.src = newImageUrl;
      } else {
        const newImg = document.createElement("img");
        newImg.src = newImageUrl;
        container.appendChild(newImg);
      }
    }
  });

  if (document.body.classList.contains("digi-gallery-ready")) {
    document
      .querySelectorAll(".product__media-list")
      .forEach((list) => list.classList.add("digi-loaded"));
  }
}

document.addEventListener("DOMContentLoaded", updateMediaGallery);
const observerUpdateGallery = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList" || mutation.type === "attributes") {
      updateMediaGallery();
    }
  }
});
const configuratorContainer = document.querySelector(".product-configurator");
if (configuratorContainer) {
  observerUpdateGallery.observe(configuratorContainer, {
    childList: true,
    subtree: true,
    attributes: true,
  });
}

document.addEventListener("click", (e) => {
  const playBtn = e.target.closest(
    ".deferred-media__poster-button--play-model",
  );
  if (playBtn) {
    const modalItem = playBtn.closest(".product-media-modal__item");
    if (modalItem) {
      const replacedImg = modalItem.querySelector(".digi-replaced-img");
      if (replacedImg) {
        if (!playBtn.dataset.played) {
          playBtn.dataset.played = "true";
          setTimeout(() => {
            replacedImg.style.display = "none";
          }, 1000);
        } else {
          replacedImg.style.display = "none";
        }
      }
    }
    return;
  }

  const closeBtn = e.target.closest(".deferred-media__poster-close-model");
  if (closeBtn) {
    const modalItem = closeBtn.closest(".product-media-modal__item");
    if (modalItem) {
      const replacedImg = modalItem.querySelector(".digi-replaced-img");
      if (replacedImg) replacedImg.style.display = "";
    }
  }
});

/* Info o tkaninie na zdjeciu */
function updateFabricInfoOnce() {
  const colorParam = document.querySelector(
    '.product__params__param[data-name="Kolor"]',
  );
  if (!colorParam) return;

  let fabricName = colorParam.textContent.trim();
  fabricName = fabricName.replace(/\d+$/, "").trim();
  if (!fabricName) return;

  const configTranslatorKeys = window.digiI18n?.configurator || {};

  document
    .querySelectorAll(".product__media-wrapper media-gallery")
    .forEach((wrapper) => {
      const firstLi = wrapper.querySelector("ul > li:first-child");
      if (!firstLi) return;

      let info = firstLi.querySelector(".digi-fabric-info");
      if (!info) {
        info = document.createElement("div");
        info.className = "digi-fabric-info";
        firstLi.appendChild(info);
      }
      if (info.textContent !== configTranslatorKeys.currentConfiguration) {
        info.textContent = configTranslatorKeys.currentConfiguration;
      }
    });

  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  const observerF = new MutationObserver(() => {
    updateFabricInfoOnce();
  });
  observerF.observe(document.body, { childList: true, subtree: true });
});
